import { render, staticRenderFns } from "./ReferralsIndexListing.vue?vue&type=template&id=affb542e"
import script from "./ReferralsIndexListing.vue?vue&type=script&lang=js"
export * from "./ReferralsIndexListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports